import React from 'react';
import PropTypes from 'prop-types';
import PageTitle from '../../FormElements/PageTitle';
import PropertiesIndexCard from '../../Dashboard/PropertiesIndexCard';
import PrimaryButton from '../../Buttons/PrimaryButton';

export default function DashboardPage({ 
  get_accounts_by_user_endpoint,
  get_properties_by_account_endpoint
}) {
  // Handle loading and error states
  if (!get_accounts_by_user_endpoint || !get_properties_by_account_endpoint) {
    return <div>Error: Missing endpoints required for DashboardPage component</div>;
  }

  return (
    <div>
      <div className="mt-4">
        <PageTitle title="Dashboard" />
        <div className="grid grid-cols-1">
          <PropertiesIndexCard
            get_accounts_by_user_endpoint={get_accounts_by_user_endpoint}
            get_properties_by_account_endpoint={get_properties_by_account_endpoint}
          />
        </div>
      </div>
      <div className="grid grid-cols-1">
        <div className="lg:justify-self-start mb-8 lg:mb-0">
          <PrimaryButton label="Add another property" url="/cart" />
        </div>
      </div>
    </div>
  );
}

DashboardPage.propTypes = {
  get_accounts_by_user_endpoint: PropTypes.string.isRequired,
  get_properties_by_account_endpoint: PropTypes.string.isRequired
};
